import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Tempotravelleronrentmumbai() {



const cardData = {
  keyword: " Tempo Traveller On Rent Mumbai",

headingDescription:
  "Omshree Cab offers reliable and spacious Tempo Traveller on rent in Mumbai for travelers who need comfortable group travel solutions for family trips, corporate outings, airport transfers, weddings, events, or outstation journeys. Our Tempo Traveller rentals are ideal for large groups, accommodating up to 9, 12, 15, or more passengers with ample luggage space and air‑conditioned comfort. We provide flexible booking options including one‑way rides, round trips, hourly rentals, and full‑day packages at transparent pricing. Each Tempo Traveller in our fleet is well‑maintained, regularly serviced, and driven by professional chauffeurs familiar with Mumbai’s routes and traffic. With easy booking, punctual pickups from any location in Mumbai (including airports, railway stations, hotels, and residential areas), and 24/7 customer support, renting a Tempo Traveller in Mumbai becomes a stress‑free and comfortable travel experience for all your group needs.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "The Gateway of India is one of Mumbai’s most iconic landmarks located along the Arabian Sea. Built during the British era, this historic monument attracts visitors for photography, sightseeing, and ferry rides to Elephanta Island. Renting a Tempo Traveller makes it convenient for large families or tour groups to visit this famous destination together without worrying about multiple vehicles or parking challenges."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal road stretching along the Arabian Sea, known as the Queen’s Necklace because the streetlights resemble a glowing necklace at night. Visitors enjoy sunset views, evening walks, and relaxed drives along the promenade. A Tempo Traveller rental allows larger groups to enjoy a comfortable ride together while exploring this iconic route."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is a popular seaside spot in Mumbai known for its sandy shores, sunset views, and vibrant street food culture. Families, friends, and tourists flock here to enjoy snacks like pav bhaji, bhel puri, and pani puri. Renting a Tempo Traveller ensures plenty of seating and space for everyone, making it easier to plan a group outing to the beach."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a revered Hindu temple dedicated to Lord Ganesha and one of Mumbai’s most visited spiritual sites. Devotees and tourists visit to seek blessings and experience the temple’s serene environment. A Tempo Traveller rental provides comfortable and spacious transport for large groups visiting the temple, especially during festivals when private transport and parking can be challenging."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "The Bandra Worli Sea Link is a modern cable‑stayed bridge connecting Bandra and Worli across the Arabian Sea. The bridge offers breathtaking views of the sea and skyline, especially during sunset and nighttime. Renting a Tempo Traveller allows large groups to travel together comfortably while enjoying the scenic views and making stops for photographs and sightseeing."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous mosque and shrine located on a small island off the coast of Mumbai. The shrine attracts visitors from different walks of life who come for prayers and to enjoy the peaceful surroundings. Renting a Tempo Traveller provides ample space and comfort for groups visiting this spiritual destination together without the hassle of parking."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock‑cut caves located on Elephanta Island and are famous for their historic stone carvings dedicated to Lord Shiva. Visitors travel by ferry from the Gateway of India to explore this UNESCO World Heritage Site. Renting a Tempo Traveller ensures that large groups can comfortably reach the ferry terminal and begin their cultural excursion together."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large urban forest reserve offering trekking, nature trails, wildlife, and the ancient Kanheri Caves. Nature lovers and families visit this green space to enjoy outdoor activities and scenic tranquility. Renting a Tempo Traveller provides enough seating and storage for gear, making it ideal for a full‑day group trip to the park."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a vibrant shopping street in South Mumbai known for its lively markets, fashion stalls, handicrafts, and local eateries. Visitors enjoy browsing through a variety of products and sampling local foods. Renting a Tempo Traveller makes it easy for larger groups to visit this bustling marketplace as part of their Mumbai sightseeing itinerary."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are beautifully landscaped terraces located on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. Families and groups often visit for peaceful walks, photography, and relaxation. Renting a Tempo Traveller provides a comfortable and spacious ride to this scenic garden, perfect for group day trips."
  }
],



services: [
{
name: "Tempo Traveller on Rent Mumbai",
description: "Tempo Traveller on rent in Mumbai offers spacious and comfortable group transportation for family trips, corporate outings, and tourist travel. These vehicles are designed with comfortable seating, ample legroom, and powerful engines suitable for city roads and long highway journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family tours, group sightseeing, and pilgrimage travel. Air-conditioned interiors ensure comfortable journeys for passengers. Flexible booking options allow convenient reservations anytime."
},
{
name: "Tempo Traveller Rental Mumbai",
description: "Tempo Traveller rental in Mumbai provides reliable group travel solutions for passengers traveling together. These vehicles offer spacious seating capacity, comfortable interiors, and smooth highway performance. Professional drivers ensure punctual pickup and safe driving services across Mumbai and nearby destinations. Pickup services are available from homes, offices, hotels, and transport hubs. Ideal for family vacations, school trips, and corporate outings. Spacious luggage space ensures convenient travel for passengers carrying bags. Flexible rental options allow easy trip planning."
},
{
name: "Tempo Traveller Hire Mumbai",
description: "Tempo Traveller hire in Mumbai offers convenient transportation for groups traveling within the city or planning outstation trips. The vehicle provides comfortable seating arrangements and smooth driving performance for long journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family tours, weekend getaways, and business travel. Air-conditioned interiors ensure comfortable journeys. Flexible hiring options allow easy ride scheduling."
},
{
name: "Tempo Traveller Cab Service Mumbai",
description: "Tempo Traveller cab service in Mumbai provides dependable group transportation for passengers traveling together. These vehicles are equipped with spacious seating and comfortable interiors suitable for long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and transport hubs. Ideal for family travel, pilgrimage tours, and corporate trips. Large luggage space ensures convenience for group travelers. Flexible booking options allow quick reservations anytime."
},
{
name: "12 Seater Tempo Traveller Mumbai",
description: "12 seater Tempo Traveller in Mumbai is perfect for small groups and families traveling together. The vehicle offers comfortable seating with spacious interiors and smooth ride quality. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, and airport terminals. Ideal for family outings, weekend tours, and sightseeing trips. Air-conditioned interiors ensure relaxed travel experiences. Flexible booking options allow easy reservations anytime."
},
{
name: "17 Seater Tempo Traveller Mumbai",
description: "17 seater Tempo Traveller in Mumbai provides spacious transportation for medium-sized groups traveling together. These vehicles offer comfortable seating, powerful engines, and smooth highway performance for long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and railway stations. Ideal for family tours, pilgrimage travel, and corporate outings. Large luggage capacity ensures convenient travel. Flexible booking options allow convenient ride scheduling."
},
{
name: "20 Seater Tempo Traveller Mumbai",
description: "20 seater Tempo Traveller in Mumbai offers large group transportation with spacious seating and comfortable interiors. These vehicles are designed for smooth long-distance travel and group tours. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, and transport hubs. Ideal for school trips, corporate events, and group tourism. Air-conditioned interiors ensure comfortable journeys for passengers. Flexible booking options allow easy trip planning."
},
{
name: "Tempo Traveller Airport Transfer Mumbai",
description: "Tempo Traveller airport transfer in Mumbai provides convenient group transportation to and from airport terminals. These vehicles offer spacious seating and large luggage capacity suitable for travelers with baggage. Professional drivers monitor flight schedules to ensure punctual pickup and drop services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for family airport transfers, corporate groups, and tourist travel. Comfortable AC interiors ensure relaxed journeys. Flexible booking options allow advance reservations."
},
{
name: "Tempo Traveller Outstation Mumbai",
description: "Tempo Traveller outstation service in Mumbai offers comfortable long-distance group travel to nearby cities and tourist destinations. These vehicles provide smooth highway performance and spacious seating suitable for extended journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, and railway stations. Ideal for weekend tours, pilgrimage travel, and family vacations. Spacious luggage area ensures convenient travel. Flexible booking options allow easy travel planning."
},
{
name: "Tempo Traveller Family Trip Mumbai",
description: "Tempo Traveller for family trips in Mumbai provides spacious and comfortable travel for families traveling together. The vehicle offers multiple seating rows and smooth suspension suitable for long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, and railway stations. Ideal for family vacations, temple visits, and sightseeing tours. Comfortable interiors ensure relaxed travel experiences. Flexible booking options allow convenient reservations."
},
{
name: "Tempo Traveller Corporate Travel Mumbai",
description: "Tempo Traveller corporate travel in Mumbai provides reliable group transportation for company teams and business travelers. These vehicles offer comfortable seating and smooth travel suitable for professional trips. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from offices, hotels, airports, and business districts. Ideal for corporate events, employee transport, and office outings. Spacious interiors ensure comfortable travel for teams. Flexible booking options allow scheduled corporate trips."
},
{
name: "Tempo Traveller Booking Mumbai",
description: "Tempo Traveller booking in Mumbai allows passengers to easily reserve spacious vehicles for group travel. Online and phone booking options provide quick confirmation and convenient ride scheduling. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family trips, corporate travel, and tourism visits. Spacious interiors ensure comfortable journeys for passengers. Flexible booking options allow easy reservations anytime."
},
{
name: "Luxury Tempo Traveller Mumbai",
description: "Luxury Tempo Traveller in Mumbai offers premium group transportation with upgraded interiors and comfortable seating. These vehicles provide enhanced comfort, smooth highway performance, and stylish travel experience. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, and airport terminals. Ideal for VIP travel, corporate executives, and luxury family tours. Air-conditioned interiors ensure relaxing journeys. Flexible booking options allow quick reservations."
},
{
name: "AC Tempo Traveller Mumbai",
description: "AC Tempo Traveller in Mumbai provides comfortable air-conditioned group travel for passengers visiting local and outstation destinations. The vehicle ensures cool and relaxing journeys even during long trips. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family tours, corporate travel, and pilgrimage trips. Spacious interiors ensure comfortable seating. Flexible booking options allow convenient ride scheduling."
},
{
name: "Tempo Traveller Near Me Mumbai",
description: "Tempo Traveller near me in Mumbai helps passengers quickly find nearby group transportation services. These vehicles offer spacious seating and smooth travel suitable for family trips and corporate travel. Professional drivers ensure punctual pickup and safe driving services across nearby areas in Mumbai. Pickup services are available from homes, hotels, offices, and transport hubs. Ideal for group tours, sightseeing trips, and airport transfers. Comfortable interiors ensure relaxed journeys for passengers. Flexible booking options allow quick reservations."
}
],

tableData: [
["Tempo Traveller on Rent Mumbai","Tempo Traveller Rental Mumbai"],
["Tempo Traveller Hire Mumbai","Tempo Traveller Cab Service Mumbai"],
["12 Seater Tempo Traveller Mumbai","17 Seater Tempo Traveller Mumbai"],
["20 Seater Tempo Traveller Mumbai","Tempo Traveller Airport Transfer Mumbai"],
["Tempo Traveller Outstation Mumbai","Tempo Traveller Family Trip Mumbai"],
["Tempo Traveller Corporate Travel Mumbai","Tempo Traveller Booking Mumbai"],
["Luxury Tempo Traveller Mumbai","AC Tempo Traveller Mumbai"],
["Tempo Traveller Near Me Mumbai","Tempo Traveller Hire Near Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Spacious Tempo Traveller for Group Travel",
    WhyChoosedescription: "Tempo Traveller is one of the best vehicles for group travel in Mumbai. It offers spacious seating, comfortable legroom, and ample luggage space, making it ideal for family trips, corporate outings, and group tours."
  },
  {
    WhyChooseheading: "Affordable Tempo Traveller Rental",
    WhyChoosedescription: "Omshree Cabs offers competitive and transparent pricing for Tempo Traveller rentals in Mumbai. Customers receive clear details about per-kilometer charges, tolls, and travel packages before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Tempo Traveller Booking",
    WhyChoosedescription: "Our Tempo Traveller rental service in Mumbai is available 24 hours a day. Whether you need a vehicle for early morning departures or late-night travel, Omshree Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Tempo Traveller vehicles in our fleet are regularly serviced, cleaned, and sanitized to ensure passengers enjoy a safe and comfortable journey."
  },
  {
    WhyChooseheading: "Perfect for Local & Outstation Trips",
    WhyChoosedescription: "Tempo Traveller rentals are perfect for local sightseeing in Mumbai as well as outstation trips to destinations like Pune, Lonavala, Nashik, Shirdi, Mahabaleshwar, and Goa."
  },
  {
    WhyChooseheading: "Professional Drivers for Group Travel",
    WhyChoosedescription: "Our trained drivers are experienced in handling large passenger vehicles and are familiar with Mumbai roads and highway routes, ensuring safe and smooth group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your group journey begins without hassle."
  },
  {
    WhyChooseheading: "Trusted Tempo Traveller Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Tempo Traveller rentals in Mumbai because of our punctual service, comfortable vehicles, and professional drivers."
  }
]
};

const faqData = [
  { question: "Do you provide Tempo Traveller on rent in Mumbai?", answer: "Yes, Omshree Cabs provides Tempo Traveller rental services in Mumbai for local travel, airport transfers, and outstation group trips." },
  { question: "How many passengers can travel in a Tempo Traveller?", answer: "Tempo Traveller vehicles typically accommodate 12 to 17 passengers comfortably depending on the model." },
  { question: "Is Tempo Traveller suitable for group travel?", answer: "Yes, Tempo Traveller is ideal for family tours, corporate trips, pilgrimage travel, and group outings." },
  { question: "Do you provide Tempo Traveller for outstation trips?", answer: "Yes, we provide Tempo Traveller rentals from Mumbai to destinations like Pune, Lonavala, Nashik, Shirdi, Mahabaleshwar, and Goa." },
  { question: "Are Tempo Traveller vehicles air-conditioned?", answer: "Yes, we provide fully air-conditioned Tempo Traveller vehicles for comfortable travel." },
  { question: "Do you provide a driver with the vehicle?", answer: "Yes, all Tempo Traveller rentals include professional drivers experienced in long-distance travel." },
  { question: "Can I book Tempo Traveller for a full-day trip?", answer: "Yes, we offer full-day and multi-day Tempo Traveller rental packages in Mumbai." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and group travel seasons." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops for meals, sightseeing, or refreshment breaks during the journey." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Anil Shah",
    feedback:
      "We booked a Tempo Traveller from Omshree Cabs for our Mumbai to Lonavala family trip. The vehicle was very comfortable and the driver was professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Mehta",
    feedback:
      "Excellent Tempo Traveller rental service in Mumbai. Perfect vehicle for our group travel with clean interiors and a smooth ride.",
    rating: 5
  }
];



















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller On Rent Mumbai",
  "description": "Omshree Cab offers Tempo Traveller on rent in Mumbai for family trips, corporate travel, airport transfers, and outstation journeys. Available in 12, 17, and 20-seater options, our well-maintained and AC-equipped vehicles ensure comfort, safety, and luxury. Flexible booking options and affordable rates make it easy to travel with groups across Mumbai and nearby destinations.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1800"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Tempo Traveller On Rent Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides Tempo Traveller on rent in Mumbai for family trips, corporate travel, airport transfers, and outstation journeys. Available in 12, 17, and 20-seater options with AC, well-maintained vehicles, and flexible booking options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/51.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravelleronrentmumbai;